export const TestIds = {
  SignIn: {
    Email: 'SignIn-Email-TextField',
    Password: 'SignIn-Password-TextField',
    ForgotPassword: 'SignIn-ForgotPassword-Link',
    Login: 'SignIn-Login-Button',
    OpenedEyeIcon: 'SignIn-OpenedEyeIcon-Icon',
    ClosedEyeIcon: 'SignIn-ClosedEyeIcon-Icon',
  },
  ForgotPassword: {
    Email: 'ForgotPassword-Email-Textfield',
    SendResetInstructions: 'ForgotPassword-SendResetInstructions-Button',
    Cancel: 'ForgotPassword-Cancel-Link',
  },
  ResetPassword: {
    NewPassword: 'ResetPassword-NewPassword-Textfield',
    ConfirmPassword: 'ResetPassword-ConfirmPassword-Textfield',
    SaveNewPassword: 'ResetPassword-SaveNewPassword-Button',
    Cancel: 'ResetPassword-Cancel-Link',
    OpenedEyeIcon: 'ResetPassword-OpenedEyeIcon-Icon',
    ClosedEyeIcon: 'ResetPassword-ClosedEyeIcon-Icon',
  },
  ManageLists: {
    TabsContainer: 'ManageLists-TabsContainer-Box',
    BusinessActivity: {
      AddButton: 'BussinesActivity-AddButton-Button',
      EditButton: 'BussinesActivity-EditButton-Button',
      DeleteButton: 'BussinesActivity-DeleteButton-Button',
      SearchInput: 'BussinesActivity-SearchInput-Textfield',
      AddEditDialog: {
        BusinessActivity: 'AddEditBussinesActivity-BussinesActivity-Textfield',
        Cancel: 'AddEditBussinesActivity-Cancel-Button',
        Save: 'AddEditBussinesActivity-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteBussinesActivity-Cancel-Button',
        Delete: 'DeleteBussinesActivity-Save-Button',
      },
    },
    DetailTypes: {
      AddButton: 'DetailTypes-AddButton-Button',
      EditButton: 'DetailTypes-EditButton-Button',
      DeleteButton: 'DetailTypes-DeleteButton-Button',
      SearchInput: 'DetailTypes-SearchInput-Textfield',
      AddEditDialog: {
        DetailType: 'AddEditDetailType-DetailType-Textfield',
        Cancel: 'AddEditDetailType-Cancel-Button',
        Save: 'AddEditDetailType-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteDetailType-Cancel-Button',
        Delete: 'DeleteDetailType-Save-Button',
      },
    },
    TaskRelated: {
      AddButton: 'TaskRelated-AddButton-Button',
      EditButton: 'TaskRelated-EditButton-Button',
      DeleteButton: 'TaskRelated-DeleteButton-Button',
      SearchInput: 'TaskRelated-SearchInput-Textfield',
      AddEditDialog: {
        TaskRelated: 'AddEditTaskRelated-TaskRelated-Textfield',
        Cancel: 'AddEditTaskRelated-Cancel-Button',
        Save: 'AddEditTaskRelated-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteTaskRelated-Cancel-Button',
        Delete: 'DeleteTaskRelated-Save-Button',
      },
    },
    States: {
      AddButton: 'States-AddButton-Button',
      EditButton: 'States-EditButton-Button',
      DeleteButton: 'States-DeleteButton-Button',
      SearchInput: 'States-SearchInput-Textfield',
      AddEditDialog: {
        Postal: 'AddEditState-Postal-Textfield',
        LocationName: 'AddEditState-LocationName-Textfield',
        Type: 'AddEditState-Type-Textfield',
        Parent: 'AddEditState-Parent-Textfield',
        Cancel: 'AddEditState-Cancel-Button',
        Save: 'AddEditState-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteStates-Cancel-Button',
        Delete: 'DeleteStates-Save-Button',
      },
    },
    FilingCategories: {
      AddButton: 'FilingCategories-AddButton-Button',
      EditButton: 'FilingCategories-EditButton-Button',
      DeleteButton: 'FilingCategories-DeleteButton-Button',
      SearchInput: 'FilingCategories-SearchInput-Textfield',
      AddEditDialog: {
        FilingCategory: 'AddEditFilingCategory-FilingCategory-Textfield',
        Cancel: 'AddEditFilingCategory-Cancel-Button',
        Save: 'AddEditFilingCategory-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteFilingCategory-Cancel-Button',
        Delete: 'DeleteFilingCategory-Save-Button',
      },
    },
    AccountIds: {
      AddButton: 'AccountIds-AddButton-Button',
      EditButton: 'AccountIds-EditButton-Button',
      DeleteButton: 'AccountIds-DeleteButton-Button',
      SearchInput: 'AccountIds-SearchInput-Textfield',
      AddEditDialog: {
        AccountId: 'AddEditAccountId-AccountId-Textfield',
        AccountCategory: 'AddEditAccountId-AccountCategory-Dropdown',
        Cancel: 'AddEditAccountIds-Cancel-Button',
        Save: 'AddEditAccountIds-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteAccountId-Cancel-Button',
        Delete: 'DeleteAccountIds-Save-Button',
      },
    },
    AccountCategories: {
      AddButton: 'AccountCategories-AddButton-Button',
      EditButton: 'AccountCategories-EditButton-Button',
      DeleteButton: 'AccountCategories-DeleteButton-Button',
      SearchInput: 'AccountCategories-SearchInput-Textfield',
      AddEditDialog: {
        AccountCategory: 'AddEditAccountCategory-AccountCategory-Textfield',
        Cancel: 'AddEditAccountCategory-Cancel-Button',
        Save: 'AddEditAccountCategory-Save-Button',
      },
      DeleteDialog: {
        Cancel: 'DeleteAccountCategory-Cancel-Button',
        Delete: 'DeleteAccountCategory-Save-Button',
      },
    },
  },
  CreateNewClient: {
    Name: 'CreateNewClient-Name-Textfield',
    FederalLegalId: 'CreateNewClient-FederalLegalId-Textfield',
    AccountId: 'CreateNewClient-AccountId-Dropdown',
    FillingCategory: 'CreateNewClient-FillingCategory-Dropdown',
    IsActive: 'CreateNewClient-IsActive-Dropdown',
    Activity: 'CreateNewClient-Activity-Dropdown',
    BillingType: 'CreateNewClient-BillingType-Dropdown',
    IsClient: 'CreateNewClient-IsClient-Dropdown',
    DateEstablished: 'CreateNewClient-DateEstablished-DateTimePicker',
    ServiceStartingDate: 'CreateNewClient-ServiceStartingDate-DateTimePicker',
    ServiceEndingDate: 'CreateNewClient-ServiceEndingDate-DateTimePicker',
    InitialFilingDate: 'CreateNewClient-InitialFilingDate-DateTimePicker',
    FinalFilingDate: 'CreateNewClient-FinalFilingDate-DateTimePicker',
    EntityType: 'CreateNewClient-EntityType-Dropdown',
    DomesticState: 'CreateNewClient-DomesticState-Dropdown',
    FilingStatus: 'CreateNewClient-FilingStatus-Dropdown',
    CloseDate: 'CreateNewClient-CloseDate-DateTimePicker',
    FormedByUs: 'CreateNewClient-FormedByUs-Dropdown',
    AdditionalInformationTextArea: 'CreateNewClient-Textarea',
    AdditionalInformationCharactersCount: 'CreateNewClient-Box',
  },
  EditClient: {
    CurrentEntityStatus: {
      Name: 'CurrentEntityStatus-Name-Textfield',
      FederalLegalId: 'CurrentEntityStatus-FederalLegalId-Textfield',
      AccountId: 'CurrentEntityStatus-AccountId-Dropdown',
      FillingCategory: 'CurrentEntityStatus-FillingCategory-Dropdown',
      IsActive: 'CurrentEntityStatus-IsActive-Dropdown',
      Activity: 'CurrentEntityStatus-Activity-Dropdown',
      BillingType: 'CurrentEntityStatus-BillingType-Dropdown',
      IsClient: 'CurrentEntityStatus-IsClient-Dropdown',
      DateEstablished: 'CurrentEntityStatus-DateEstablished-DateTimePicker',
      EntityType: 'CurrentEntityStatus-EntityType-Dropdown',
      DomesticState: 'CurrentEntityStatus-DomesticState-Dropdown',
      SubParent: 'CurrentEntityStatus-SubParent-Dropdown',
      CloseDate: 'CurrentEntityStatus-CloseDate-DateTimePicker',
      FormedByUs: 'CurrentEntityStatus-FormedByUs-Dropdown',
      ServiceStartingDate:
        'CurrentEntityStatus-ServiceStartingDate-DateTimePicker',
      ServiceEndingDate: 'CurrentEntityStatus-ServiceEndingDate-DateTimePicker',
      InitialFilingDate: 'CurrentEntityStatus-InitialFilingDate-DateTimePicker',
      FinalFilingDate: 'CurrentEntityStatus-FinalFilingDate-DateTimePicker',
      AdditionalInformationTextArea: 'CurrentEntityStatus-Textarea',
      AdditionalInformationCharactersCount: 'CurrentEntityStatus-Box',
      ChangeBulk: 'CurrentEntityStatus-ChangeBulk-Button',
    },
    Dialogs: {
      EntityType: {
        EditEntityTypeDialog: 'EditClient-EntityType-Dialog',
        EditEntityTypeCancel: 'EditClient-EntityType-Cancel',
        EditEntityTypeSave: 'EditClient-EntityType-Save',
        EntityType: 'EditClient-EntityType-Dropdown',
        StartingDate: 'EditClient-StartingDate-DateTimePicker',
        EndingDate: 'EditClient-EndingDate-DateTimePicker',
        Description: 'EditClient-Description-Textarea',
        DescriptionCount: 'EditClient-Description-TextareaCount',
      },
      State: {
        Residence: 'EditClient-State-Residence',
        State: 'EditClient-State-State',
        Starting: 'EditClient-State-Starting',
        Ending: 'EditClient-State-Ending',
        GovID: 'EditClient-State-GovId',
        Description: 'EditClient-State-Description',
        SubmitButton: 'EditClient-State-SubmitButton',
        CancelButton: 'EditClient-State-CancelButton',
      },
      SubParent: {
        SubParentStatus: 'EditClient-SubParent-SubParentStatus',
        CurrentParent: 'EditClient-SubParent-CurrentParent',
        Starting: 'EditClient-SubParent-Starting',
        Ending: 'EditClient-SubParent-Ending',
        Description: 'EditClient-SubParent-Description',
        SubmitButton: 'EditClient-SubParent-SubmitButton',
        CancelButton: 'EditClient-SubParent-CancelButton',
      },
    },
  },
  TemplateCenter: {
    Sidebar: {
      NewTemplate: 'TemplateCenterSidebar-NewTemplate-Button',
      IncludeInactive: 'TemplateCenterSidebar-IncludeInactive-Checkbox',
      ExportToExcel: 'TemplateCenterSidebar-ExportToExcel-Button',
    },
  },
  Homepage: {
    Sidebar: {
      NewClient: 'HomepageSidebar-NewClient-Box',
      ExportToExel: 'HomepageSidebar-ExportToExel-Button',
      IncludeInactive: 'HomepageSidebar-IncludeInactive-Checkbox',
      IncludeNonClient: 'HomepageSidebar-IncludeNonClient-Checkbox',
      SearchInput: 'HomepageSidebar-SearchInput-Textfield',
      EditIcon: 'HomepageSidebar-EditIcon-Icon',
      CheckIcon: 'HomepageSidebar-CheckIcon-Icon',
      WarningIcon: 'HomepageSidebar-Warning-Icon',
      TasksTab: 'HomepageSidebar-Tasks-Tab',
      ClientsTab: 'HomepageSidebar-Clients-Tab',
      LiveLogTab: 'HomepageSidebar-LiveLog-Tab',
    },
    LiveLog: {
      Container: 'HomepageLiveLog-Container-Box',
      Table: 'HomepageLiveLog-Table-DataGrid',
      ExportToExel: 'HomepageLiveLog-ExportToExel-Button',
      TaskLink: 'HomepageLiveLog-Task-Link',
      ClientLink: 'HomepageLiveLog-Client-Link',
      Filters: {
        Container: 'HomepageLiveLogFilters-Container-Box',
        Header: 'HomepageLiveLogFilters-Header-Box',
        ExpandToggle: 'HomepageLiveLogFilters-ExpandToggle-Button',
        Since: 'HomepageLiveLogFilters-Since-DatePicker',
        AssignedTo: 'HomepageLiveLogFilters-AssignedTo-Dropdown',
        By: 'HomepageLiveLogFilters-By-Dropdown',
        Client: 'HomepageLiveLogFilters-Client-Dropdown',
        Actions: 'HomepageLiveLogFilters-Actions-Dropdown',
        Clear: 'HomepageLiveLogFilters-Clear-Button',
      },
    },
    Tasks: {
      Container: 'HomepageTasks-Container-Box',
      Table: 'HomepageTasks-Table-DataGrid',
      Count: 'HomepageTasks-Count-Text',
      ExportToExel: 'HomepageTasks-ExportToExel-Button',
      UrgentIcon: 'HomepageTasks-Urgent-Icon',
      DescriptionLink: 'HomepageTasks-Description-Link',
      ForLink: 'HomepageTasks-For-Link',
      Filters: {
        Container: 'HomepageTasksFilters-Container-Box',
        Header: 'HomepageTasksFilters-Header-Box',
        ExpandToggle: 'HomepageTasksFilters-ExpandToggle-Button',
        DueBy: 'HomepageTasksFilters-DueBy-Dropdown',
        Date: 'HomepageTasksFilters-Date-DateTimePicker',
        UrgentOnly: 'HomepageTasksFilters-UrgentOnly-Checkbox',
        TaskType: 'HomepageTasksFilters-TaskType-Dropdown',
        FilingType: 'HomepageTasksFilters-FilingType-Dropdown',
        AccountId: 'HomepageTasksFilters-AccountId-Dropdown',
        AssignedTo: 'HomepageTasksFilters-AssignedTo-Dropdown',
        Search: 'HomepageTasksFilters-Search-Textfield',
        Clear: 'HomepageTasksFilters-Clear-Button',
      },
      Creator: {
        Container: 'HomepageTaskCreator-Container-Box',
        Header: 'HomepageTaskCreator-Header-Box',
        ExpandToggle: 'HomepageTaskCreator-ExpandToggle-Button',
        Type: 'HomepageTaskCreator-Type-Dropdown',
        Save: 'HomepageTaskCreator-Save-Button',
        Clear: 'HomepageTaskCreator-Clear-Button',
        AssignedTo: 'HomepageTaskCreator-AssignedTo-Dropdown',
        Client: 'HomepageTaskCreator-Client-Dropdown',
        Description: 'HomepageTaskCreator-Description-Textfield',
        Template: 'HomepageTaskCreator-Template-Dropdown',
        EntityMismatch: 'HomepageTaskCreator-EntityMismatch-Text',
        Note: 'HomepageTaskCreator-Note-Textfield',
        SubType: 'HomepageTaskCreator-SubType-Dropdown',
        Detail: 'HomepageTaskCreator-Detail-Dropdown',
        Related: 'HomepageTaskCreator-Related-Dropdown',
        DueDate: 'HomepageTaskCreator-DueDate-DateTimePicker',
        ShowUntilDone: 'HomepageTaskCreator-ShowUntilDone-Toggle',
        Billable: 'HomepageTaskCreator-Billable-Toggle',
        Amount: 'HomepageTaskCreator-Amount-Currency',
        CallbackNumber: 'HomepageTaskCreator-CallbackNumber-PhoneField',
        Urgent: 'HomepageTaskCreator-Urgent-Toggle',
        TaxYear: 'HomepageTaskCreator-TaxYear-DigitsInput',
        TaxPaymentFiling: 'HomepageTaskCreator-TaxPaymentFiling-Dropdown',
        TaxPaymentTemplate: 'HomepageTaskCreator-TaxPaymentTemplate-Dropdown',
        TaxPaymentType: 'HomepageTaskCreator-TaxPaymentType-Dropdown',
        Paid: 'HomepageTaskCreator-Paid-Checkbox',
        EstimatedAmount: 'HomepageTaskCreator-EstimatedAmount-Currency',
        DatePaid: 'HomepageTaskCreator-DatePaid-DateTimePicker',
        PaymentMethod: 'HomepageTaskCreator-PaymentMethod-Dropdown',
        OverpaymentAmount: 'HomepageTaskCreator-OverpaymentAmount-Currency',
        OverpaymentSetting: 'HomepageTaskCreator-OverpaymentSetting-Dropdown',
        Important: 'HomepageTaskCreator-Important-Toggle',
        NoteRelatedTo: 'HomepageTaskCreator-NoteRelatedTo-Dropdown',
        SpecificTemplate: 'HomepageTaskCreator-SpecificTemplate-Dropdown',
      },
    },
  },
  MainNavigation: {
    Container: 'MainNavigation-Container-Box',
  },
  MainTabs: {
    Container: 'MainTabs-Container-Box',
    TabName: 'MainTabs-TabName-Text',
    PenIcon: 'MainTabs-PenIcon-Icon',
    CloseIcon: 'MainTabs-CloseIcon-Icon',
    HomeTab: 'MainTabs-HomeTab-Tab',
  },
  PageFooterActions: {
    Container: 'PageFooter-Container-Box',
  },
  TaskGenerationLog: {
    ExpandButton: 'TaskGenerationLog-Expand-Button',
    RunDetailsDialog: 'TaskGenerationLog-RunDetails-Dialog',
    RetryButton: 'TaskGenerationLog-Retry-Button',
    FailedSearch: 'TaskGenerationLog-Failed-Search',
    SuccessfulSearch: 'TaskGenerationLog-Successful-Search',
    SkippedSearch: 'TaskGenerationLog-Skipped-Search',
  },
  Workflow: {
    Container: 'Workflow-Container-Box',
    Step: 'Workflow-Step-Box',
    StatusDropdown: 'Workflow-Status-Dropdown',
    AssignedDropdown: 'Workflow-Assigned-Dropdown',
    DoneButton: 'Workflow-Done-Button',
    UndoButton: 'Workflow-Undo-Button',
    ToggleButton: 'Workflow-Toggle-Button',
    RequiredTodosDialogConfirm: 'Workflow-RequiredTodos-Confirm-Button',
    RelatedTasksOpenDialogConfirm: 'Workflow-RelatedTasksOpen-Confirm-Button',
    RelatedTasksOpenDialogCancel: 'Workflow-RelatedTasksOpen-Cancel-Button',
    OpenItemsBlockedDialogConfirm: 'Workflow-OpenItemsBlocked-Confirm-Button',
  },
  TaskSidebar: {
    ToggleButton: 'TaskSidebar-Toggle-Button',
    Note: {
      Box: 'TaskSidebarNote-Box-Textfield',
      AddButton: 'TaskSidebarNote-Add-Button',
      Dialog: {
        Container: 'AddNote-Container-Dialog',
        Note: 'AddNote-Note-Textfield',
        Type: 'AddNote-Type-Dropdown',
        Period: 'AddNote-Period-Dropdown',
        AssignedTo: 'AddNote-AssignedTo-Dropdown',
        BlocksAssignment: 'AddNote-BlocksAssignment-Dropdown',
        Important: 'AddNote-Important-Toggle',
        RelatedTo: 'AddNote-RelatedTo-Dropdown',
        SpecificTemplate: 'AddNote-SpecificTemplate-Dropdown',
        Alert: 'AddNote-Alert-Toggle',
        AlertFor: 'AddNote-AlertFor-Dropdown',
        Save: 'AddNote-Save-Button',
        Cancel: 'AddNote-Cancel-Button',
      },
    },
  },
  TaskDetails: {
    Assignments: {
      EditIcon: 'TaskDetailsAssignments-Edit-IconButton',
      AlertIndicator: 'TaskDetailsAssignments-Alert-IconButton',
    },
    AlertViewer: {
      Dismiss: 'AlertViewer-Dismiss-Button',
      Close: 'AlertViewer-Close-Button',
    },
    RelatedTasks: {
      AddButton: 'TaskDetailsRelatedTasks-Add-Button',
      ExportButton: 'TaskDetailsRelatedTasks-Export-Button',
      EditIcon: 'TaskDetailsRelatedTasks-Edit-IconButton',
      DeleteIcon: 'TaskDetailsRelatedTasks-Delete-IconButton',
      DescriptionLink: 'TaskDetailsRelatedTasks-Description-Link',
      Dialog: {
        Type: 'AddRelatedTask-Type-Dropdown',
        AssignedTo: 'AddRelatedTask-AssignedTo-Dropdown',
        Description: 'AddRelatedTask-Description-Textfield',
        LinkedAssignment: 'AddRelatedTask-LinkedAssignment-Dropdown',
        Note: 'AddRelatedTask-Note-Textfield',
        ShowUntilDone: 'AddRelatedTask-ShowUntilDone-Toggle',
        DueDate: 'AddRelatedTask-DueDate-DateTimePicker',
        SubType: 'AddRelatedTask-SubType-Dropdown',
        Detail: 'AddRelatedTask-Detail-Dropdown',
        Related: 'AddRelatedTask-Related-Dropdown',
        Save: 'AddRelatedTask-Save-Button',
        Cancel: 'AddRelatedTask-Cancel-Button',
      },
    },
    Filings: {
      EditIcon: 'TaskDetailsFilings-Edit-IconButton',
      DeleteIcon: 'TaskDetailsFilings-Delete-IconButton',
    },
    Notes: {
      Table: 'TaskDetailsNotes-Table-DataGrid',
      ShowAllToggle: 'TaskDetailsNotes-ShowAll-Toggle',
      ImportantIcon: 'TaskDetailsNotes-Important-Icon',
      EditIcon: 'TaskDetailsNotes-Edit-IconButton',
      DeleteIcon: 'TaskDetailsNotes-Delete-IconButton',
      Dialog: {
        Note: 'EditNote-Note-Textfield',
        Type: 'EditNote-Type-Dropdown',
        Important: 'EditNote-Important-Toggle',
        RelatedTo: 'EditNote-RelatedTo-Dropdown',
        SpecificTemplate: 'EditNote-SpecificTemplate-Dropdown',
        Alert: 'EditNote-Alert-Toggle',
        AlertFor: 'EditNote-AlertFor-Dropdown',
        Save: 'EditNote-Save-Button',
        Cancel: 'EditNote-Cancel-Button',
      },
      DeleteBlocked: {
        Ok: 'DeleteNoteBlocked-Ok-Button',
      },
      DeleteConfirm: {
        Delete: 'DeleteNoteConfirm-Delete-Button',
        Cancel: 'DeleteNoteConfirm-Cancel-Button',
      },
    },
    ReceivedK1s: {
      FiltersToggle: 'TaskDetailsReceivedK1s-FiltersToggle-Button',
      FiltersContainer: 'TaskDetailsReceivedK1s-Filters-Popover',
      WeFileFilter: 'TaskDetailsReceivedK1s-WeFile-Dropdown',
      K1ProviderFilter: 'TaskDetailsReceivedK1s-K1Provider-Textfield',
      DirectSourceFilter: 'TaskDetailsReceivedK1s-DirectSource-Dropdown',
      ClearFilters: 'TaskDetailsReceivedK1s-ClearFilters-Button',
    },
    OpenItems: {
      OpenItemsTable: 'TaskDetailsOpenItems-OpenItems-DataGrid',
      ForNextPeriodTable: 'TaskDetailsOpenItems-ForNextPeriod-DataGrid',
      TabsContainer: 'TaskDetailsOpenItems-Tabs-Container',
      FiltersToggle: 'TaskDetailsOpenItems-FiltersToggle-Button',
      FiltersContainer: 'TaskDetailsOpenItems-Filters-Popover',
      IncludeDoneCheckbox: 'TaskDetailsOpenItems-IncludeDone-Checkbox',
      ClearFilters: 'TaskDetailsOpenItems-ClearFilters-Button',
      AssignedToFilter: 'TaskDetailsOpenItems-AssignedTo-Dropdown',
      BlocksAssignmentFilter: 'TaskDetailsOpenItems-BlocksAssignment-Dropdown',
      DoneButton: 'TaskDetailsOpenItems-Done-Button',
      EditIcon: 'TaskDetailsOpenItems-Edit-IconButton',
      DeleteIcon: 'TaskDetailsOpenItems-Delete-IconButton',
      UndoBlocked: {
        Ok: 'OpenItemUndoBlocked-Ok-Button',
      },
      DeleteConfirm: {
        Delete: 'OpenItemDelete-Confirm-Button',
        Cancel: 'OpenItemDelete-Cancel-Button',
      },
    },
    TaxPayments: {
      AddButton: 'TaskDetailsTaxPayments-Add-Button',
      EditIcon: 'TaskDetailsTaxPayments-Edit-IconButton',
      Dialog: {
        Filing: 'AddTaxPayment-Filing-Dropdown',
        Template: 'AddTaxPayment-Template-Dropdown',
        Type: 'AddTaxPayment-Type-Dropdown',
        AssignedTo: 'AddTaxPayment-AssignedTo-Dropdown',
        Paid: 'AddTaxPayment-Paid-Checkbox',
        DueDate: 'AddTaxPayment-DueDate-DateTimePicker',
        EstimatedAmount: 'AddTaxPayment-EstimatedAmount-Currency',
        DatePaid: 'AddTaxPayment-DatePaid-DateTimePicker',
        Amount: 'AddTaxPayment-Amount-Currency',
        PaymentMethod: 'AddTaxPayment-PaymentMethod-Dropdown',
        OverpaymentSetting: 'AddTaxPayment-OverpaymentSetting-Dropdown',
        Note: 'AddTaxPayment-Note-Textfield',
        Save: 'AddTaxPayment-Save-Button',
        Cancel: 'AddTaxPayment-Cancel-Button',
      },
    },
    FilingDates: {
      MarkFinalLink: 'TaskDetailsFilingDates-MarkFinal-Link',
      MarkFinalConfirm: 'TaskDetailsFilingDates-MarkFinalConfirm-Button',
      MarkFinalCancel: 'TaskDetailsFilingDates-MarkFinalCancel-Button',
      MarkFinalBlockedConfirm:
        'TaskDetailsFilingDates-MarkFinalBlockedConfirm-Button',
    },
    SubFilingFinal: {
      MarkFinalLink: 'TaskDetailsSubFilingFinal-MarkFinal-Link',
      MarkFinalConfirm: 'TaskDetailsSubFilingFinal-MarkFinalConfirm-Button',
      MarkFinalCancel: 'TaskDetailsSubFilingFinal-MarkFinalCancel-Button',
    },
  },
} as const;

const Components = {
  Textfield: 'Textfield',
  Dropdown: 'Dropdown',
  PhoneField: 'PhoneField',
  Dialog: 'Dialog',
  TooltipErrors: 'TooltipErrors',
} as const;
type Component = (typeof Components)[keyof typeof Components];

export const ComponentTestIds = {
  Textfield: {
    ErrorIcon: 'Textfield-ErrorIcon-Icon',
  },
  Dropdown: {
    Arrow: 'Dropdown-Arrow-Icon',
  },
  PhoneField: {
    Arrow: 'PhoneField-Arrow-Icon',
  },
  Dialog: {
    CloseIcon: 'ConfirmationDialog-CloseIcon-Icon',
  },
  TooltipErrors: {
    ErrorIcon: 'TooltipErrors-ErrorIcon-Icon',
    Message: 'TooltipErrors-Message',
  },
} as const satisfies { [k in Component]?: {} };
